export const PLANOS_LOADING = 'PLANOS_LOADING';
export const PLANOS_SET = 'PLANOS_SET';


export const CHANGE_CLIENTE_PLANOS = 'CHANGE_CLIENTE_PLANOS';
export const CHANGE_PLANO_CLIENTE_LOADING = 'CHANGE_PLANO_CLIENTE_LOADING';

export const SET_PLANOS_PAGINATED = 'SET_PLANOS_PAGINATED';
export const SET_PLANO = 'SET_PLANO';